import singaporeImage from '~/assets/images/performance/singapore-fw.png'
import unitedStatesImage from '~/assets/images/performance/unitedstates-fw.png'
import unitedKingdomImage from '~/assets/images/performance/unitedkingdom-fw.png'
import australiaImage from '~/assets/images/performance/australia-fw.png'
import newFrameworkImage from '~/assets/images/performance/new-fw.png'

export function getAppraisalStandardsImage(appraisalName) {
  switch (appraisalName) {
    case 'Singapore':
      return singaporeImage
    case 'United States':
      return unitedStatesImage
    case 'United Kingdom':
      return unitedKingdomImage
    case 'Australia':
      return australiaImage
    default:
      return newFrameworkImage
  }
}

export const AppraisalRecordStatus = {
  DEACTIVATE: 'DEACTIVATE',
  DRAFT: 'DRAFT',
  FINALIZED: 'FINALIZED',
  SUBMITTED: 'SUBMITTED',
  SIGNED_OFF: 'SIGNED_OFF',
}

export const AppraisalRecordType = {
  SELF: 'SELF',
  PEER: 'PEER',
  MANAGER: 'MANAGER',
}

export const AppraisalFrameworkStatus = {
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
  DELETED: 'DELETED',
  DELETED_FOREVER: 'DELETED_FOREVER',
  DRAFT: 'DRAFT',
  MOVE_BACK: 'MOVE_BACK',
}

export const ShowHideContentSettings = {
  HIDE: 'HIDE',
  SHOW_ALL: 'SHOW_ALL',
  SHOW_NOTES: 'SHOW_NOTES',
}

export const ChangesToFinalisedSettings = {
  ALLOW: 'ALLOW',
  DISALLOW: 'DISALLOW',
}

export const APPRAISAL_ACTION_TYPES = {
  OPEN_APPRAISAL: 'OPEN_APPRAISAL',
}

export const APPRAISAL_BUTTON_TYPES = {
  PRIMARY: 'PRIMARY',
}

export const APPRAISAL_DEFAULT_BUTTONS = {
  VIEW: {
    actionType: APPRAISAL_ACTION_TYPES.OPEN_APPRAISAL,
    buttonText: 'View',
    buttonType: APPRAISAL_BUTTON_TYPES.PRIMARY,
  },
}
